import etaMdl from './eta.middleware';
import acceptMdl from './accept.middleware';
import rejectMdl from './reject.middleware';

export default [...etaMdl, ...acceptMdl, ...rejectMdl];
